import React from "react";
import {
  AlertDialog, AlertDialogAction, AlertDialogCancel, AlertDialogContent,
  AlertDialogDescription, AlertDialogFooter, AlertDialogHeader, AlertDialogTitle,
} from "../ui/alert-dialog";

const SettingsDeleteDialog = ({ deleteDialog, setDeleteDialog, handleDelete }) => (
  <AlertDialog open={deleteDialog.open} onOpenChange={(open) => setDeleteDialog({ ...deleteDialog, open })}>
    <AlertDialogContent className="bg-background border-border">
      <AlertDialogHeader>
        <AlertDialogTitle className="text-foreground">Confirm Delete</AlertDialogTitle>
        <AlertDialogDescription className="text-muted-foreground">
          Are you sure you want to delete &quot;{deleteDialog.name}&quot;? This action cannot be undone.
        </AlertDialogDescription>
      </AlertDialogHeader>
      <AlertDialogFooter>
        <AlertDialogCancel className="bg-theme-surface text-foreground border-theme hover:bg-theme-hover">Cancel</AlertDialogCancel>
        <AlertDialogAction onClick={handleDelete} className="bg-red-600 hover:bg-red-700 text-white">Delete</AlertDialogAction>
      </AlertDialogFooter>
    </AlertDialogContent>
  </AlertDialog>
);

export default SettingsDeleteDialog;
